import React, { useState } from 'react';

const FILTER_LABELS = {
	all: 'All',
	activate: 'Activate',
	deactivate: 'Deactivate & Uninstall',
	pro: 'Pro',
	free: 'Free',
};

function FilterDropdown({ onFilterChange, showPlanFilters = false }) {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState('All');

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};

	const handleSelect = (value) => {
		setSelectedValue(FILTER_LABELS[value] || value);
		setIsOpen(false);
		onFilterChange(value);
	};

	return (
		<div className="telemetry-select-dd no-seprator telemetry-change-length">
			<span onClick={toggleDropdown}>{selectedValue}</span>

			{isOpen && (
				<ul className="telemetry-dd">
					<li onClick={() => handleSelect('all')}>All</li>
					<li onClick={() => handleSelect('activate')}>Activate</li>
					<li onClick={() => handleSelect('deactivate')}>Deactivate & Uninstall</li>
					{showPlanFilters && (
						<>
							<li onClick={() => handleSelect('pro')}>Pro</li>
							<li onClick={() => handleSelect('free')}>Free</li>
						</>
					)}
				</ul>
			)}
		</div>
	);
}

export default FilterDropdown;